import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/static/home/lince.png'
import _imports_1 from '../../../assets/static/companies_logos/circulo.svg'
import _imports_2 from '../../../assets/static/companies_logos/plasvale.svg'
import _imports_3 from '../../../assets/static/companies_logos/lince_international.svg'


const _withScopeId = n => (_pushScopeId("data-v-6830d3f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "supporters" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "supporters__images" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "supporters__card" }, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      class: "supporters__images__link",
      href: "https://www.lince.com.br/"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "supporters__card-image" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_0,
          title: "Logo da Lince",
          class: "logo lince",
          alt: "Logo da Lince"
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", null, " O Grupo Lince é composto pelas empresas Lince, Circulo e Plasvale. A Lince gerencia funções essenciais para o funcionamento do grupo, centralizando o desenvolvimento dos sistemas corporativos, assessoria jurídica, intermediação e assessoramento de negócios. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "supporters__card" }, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      class: "supporters__images__link",
      href: "https://www.circulo.com.br/"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "supporters__card-image" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_1,
          class: "logo circulo",
          title: "Logo da Círculo",
          alt: "Logo da Círculo"
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", null, " Produtora de fios e linhas para trabalhos manuais. Uma das maiores indústrias têxteis do Brasil que busca a cada lançamento, inovação e modernidade através de cores e texturas diferenciadas, sem deixar de lado a tradição e o cuidado com matérias primas de qualidade. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "supporters__card" }, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      class: "supporters__images__link",
      href: "https://www.plasvale.com.br/"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "supporters__card-image" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_2,
          title: "Logo da Plasvale",
          alt: "Logo da Plasvale",
          class: "logo plasvale"
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", null, " Facilitar a vida das pessoas é o que move a Plasvale, que desde 1977 busca tornar a vida de cada um dos nossos consumidores mais fácil. Cada produto e cada detalhe são pensados com amor e de forma sustentável pelos nossos mais de 600 colaboradores que juntos produzem materiais com design inovadores e com a qualidade que só os produtos Plasvale oferecem. ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "supporters__card" }, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      class: "supporters__images__link",
      href: "https://www.lince.com.br/"
    }, [
      /*#__PURE__*/_createElementVNode("div", { class: "supporters__card-image" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_3,
          title: "Logo da Lince International",
          alt: "Logo da Lince International",
          class: "logo lice_international",
          width: "90",
          height: "50"
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", null, " A Lince International, localizada na Florida, nasceu em 2019 com o objetivo de ser a base de apoio para o crescimento das empresas do Grupo Lince no maior e mais importante mercado consumidor do mundo, os Estados Unidos da América. Hoje, serve como uma distribuidora e facilitadora de negócios para todas as empresas do grupo, sendo uma importante ferramenta para levar os nossos produtos a todos os lares americanos. ")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionDivisor = _resolveComponent("SectionDivisor")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_SectionDivisor, {
      title: "Nossos apoiadores",
      colorLabel: "var(--primary-color)",
      "color-background": "#fafafa",
      "color-line": "var(--primary-color)"
    }),
    _hoisted_2
  ]))
}